export enum EMediaType {
  PDF = "pdf",
  JSON = "json",
}
